<template>
  <Screen>
    <AppBar :title="title" />
    <Breadcrumbs
      :links="[
        {
          to: $route('admin.blissdom.breathingexercise.index'),
          title: 'Breathing exercises',
        },
      ]"
      :title="title"
    />
    <div class="card card-body">
      <div class="row">
        <div class="col-lg-6">
          <form action="" method="post" @submit.prevent="submit" v-if="formSet">
            <TextBox
              name="title"
              v-model="form.title"
              :disabled="form.processing"
              :error="form.errors.title"
            />
            <TextBox
              name="sort_order"
              v-model="form.sort_order"
              :disabled="form.processing"
              :error="form.errors.sort_order"
              helperText="Higher the number, higher the priority"
            />
            <div class="content-type-help">
              <p>
                Kindly make sure to add http:// or https:// before the link.
              </p>
              <p>Content or website will be displayed in app as an iframe.</p>
              <p>Examples are provided below.</p>
              <table class="table mb-0">
                <tr>
                  <th>Example</th>
                  <th>URL</th>
                </tr>
                <tr v-for="externalUrl in externalUrls" :key="externalUrl.url">
                  <td v-text="externalUrl.title"></td>
                  <td v-text="externalUrl.url"></td>
                </tr>
              </table>
            </div>
            <TextBox
              name="external_url"
              label="Youtube/Vimeo/Canva embed url"
              v-model="form.external_url"
              :disabled="form.processing"
              :error="form.errors.external_url"
            />
            <FileInput
              name="thumbnail"
              v-model="form.thumbnail"
              :fileUrl="form.thumbnail_url"
              :disabled="form.processing"
              :error="form.errors.thumbnail"
              helperText="Ideal size is 600x600 pixels or aspect ratio of 1:1. Upload svg file for better quality"
            />
            <div class="row">
              <div class="col-auto">
                <StatusRadio
                  v-model="form.isactive"
                  :disabled="form.processing"
                  :error="form.errors.isactive"
                />
              </div>
              <div class="col-auto">
                <StatusRadio
                  label="Premium content"
                  :radioLabel="['Premium', 'Free']"
                  name="is_premium"
                  v-model="form.is_premium"
                  :disabled="form.processing"
                  :error="form.errors.is_premium"
                />
              </div>
            </div>

            <div class="mt-4 text-center">
              <button
                class="btn btn-primary w-25"
                type="submit"
                :disabled="form.processing"
                @click.prevent="submit"
              >
                <div
                  class="spinner-border spinner-border-sm"
                  role="status"
                  v-if="form.processing"
                ></div>
                <span v-else>Save</span>
              </button>
            </div>
          </form>
        </div>
        <div class="col-lg-6">
          <hr class="d-block d-lg-none" />
          <h4>Preview</h4>
          <hr />
          <MobilePreview
            :title="form.title"
            :content="form.external_url"
            content_type="url"
          />
        </div>
      </div>
    </div>
  </Screen>
</template>
<script>
import FileInput from "@/components/form/fileInput.vue";
import MobilePreview from "../components/mobilePreview.vue";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    formData: {
      type: [Object, Array],
      default: () => {},
    },
    submitUrl: {
      type: String,
      default: "",
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FileInput,
    MobilePreview,
  },
  data() {
    return {
      form: {},
      formSet: false,
      fileName: "Choose file",
      externalUrls: [
        {
          title: "Youtube video",
          url: "https://www.youtube.com/embed/{VIDEO_ID}",
        },
        {
          title: "Vimeo video",
          url: "https://player.vimeo.com/video/{VIDEO_ID}",
        },
        {
          title: "Daily Motion video",
          url: "https://www.dailymotion.com/embed/video/{VIDEO_ID}",
        },
        {
          title: "Canva",
          url: "https://www.canva.com/design/{DESIGN_ID}/view?embed",
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.form = this.$inertia.form(this.formData);
      this.fileName = this.form.audio || "Choose file";
      this.form.audio = null;
      this.form.thumbnail = null;
      setTimeout(() => {
        this.formSet = true;
      });
    });
  },
  methods: {
    submit() {
      this.form.post(this.submitUrl, {
        onSuccess: () => this.form.reset(),
      });
    },
    audioOnChange(event) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      reader.onload = () => {
        this.fileName = event.target.files[0].name;
        this.form.audio = event.target.files[0];
      };
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.content-type-help {
  padding: 1rem;
  border: 2px solid var(--warning);
  border-radius: var(--border-radius);
  margin-bottom: 1rem;
}
</style>